import React from 'react';
import ReactDOM from 'react-dom';

import 'core-js';

import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
